module.exports = __webpack_public_path__ + "static/media/PoweredBySSLogo.cd9a1b47.svg";